import "./webpack-entry";
import "./locales/registerEnterpriseTranslations";
import { PluginManifest, PluginStore } from "graylog-web-plugin/plugin";
import mergePluginBindings from "util/mergePluginBindings";
import archiveBindings from "archive/bindings";
import auditlogBindings from "auditlog/bindings";
import collectionBindings from "collections/bindings";
import customizationBindings from "customization/bindings";
import dataTieringBindings from "data-tiering/bindings";
import failureBindings from "failure/bindings";
import forwarderBindings from "forwarder/bindings";
import healthBindings from "health/bindings";
import illuminateBindings from "illuminate/bindings";
import inputSetupWizardBindings from "input-setup-wizard/bindings";
import licenseBindings from "license/bindings";
import supportBundleBindings from "support-bundle/binding";
import reportBindings from "report/bindings";
import lookupBindings from "lookup/bindings";
import logViewBindings from "logview/bindings";
import securityAppBindings from "security-app/bindings";
import eventProceduresBindings from "security-app/components/SecurityEvents/EventProcedures/bindings";
import detectionChainsBindings from "security-app/components/DetectionChains/bindings";
import securityBindings from "security/bindings";
import externalValueActionsBindings from "security-content/bindings.externalValueActions";
import authenticationBindings from "authentication/bindings";
import parameterBindings from "enterprise/parameters/ParameterBindings";
import eventCorrelationBindings from "event-correlation/bindings";
import trafficEventBindings from "license/traffic/bindings";
import trafficViolationBindings from "traffic-violation/bindings";
import indexTimeArchivingBindings from "data-lake/bindings";
import exportBindings from "export/bindings";
import upsellBindings from "upsell/bindings";
import searchFilterBindings from "./search-filter/bindings";
import watchlistBindings from "./watchlist/bindings";
import watchlistManagementBindings from "./watchlist/managementBindings";
import enterpriseMenuBindings from "./EnterpriseMenuBindings";
import searchExportBindings from "./search/exportBindings";
import searchBindings from "./search/bindings";
import cloudComponentBindings from "./cloud/components/bindings";
import oidcAuthBindings from "./cloud/oidc-authentication/bindings";
import enterpriseIntegrationsExport from "./enterprise-integrations/bindings";
import datanodeBindings from "./datanode/bindings";
import internalDataLakeExport from "./data-lake/preview/storage-types/internal/bindings";
import externalDataLakeExport from "./data-lake/preview/storage-types/external/bindings";
import widgetSummaryBindings from "./ai/bindings";
import agentWorkflowBindings from "./aiagent/bindings";
import aiManagementBindings from "./ai-management/bindings";
import suggestionsBindings from "./aiagent/suggestions/bindings";
import packageJson from "../../package.json";
const bindings = mergePluginBindings(
  archiveBindings,
  auditlogBindings,
  authenticationBindings,
  externalDataLakeExport,
  customizationBindings,
  dataTieringBindings,
  enterpriseMenuBindings,
  eventCorrelationBindings,
  exportBindings,
  externalValueActionsBindings,
  failureBindings,
  forwarderBindings,
  healthBindings,
  illuminateBindings,
  internalDataLakeExport,
  inputSetupWizardBindings,
  licenseBindings,
  supportBundleBindings,
  searchExportBindings,
  logViewBindings,
  lookupBindings,
  searchBindings,
  parameterBindings,
  reportBindings,
  searchFilterBindings,
  securityBindings,
  securityAppBindings,
  trafficEventBindings,
  trafficViolationBindings,
  watchlistBindings,
  watchlistManagementBindings,
  cloudComponentBindings,
  oidcAuthBindings,
  indexTimeArchivingBindings,
  enterpriseIntegrationsExport,
  datanodeBindings,
  upsellBindings,
  detectionChainsBindings,
  eventProceduresBindings,
  widgetSummaryBindings,
  agentWorkflowBindings,
  aiManagementBindings,
  suggestionsBindings,
  collectionBindings
);
const manifest = new PluginManifest(packageJson, bindings);
PluginStore.register(manifest);
